export class UsuarioLogado {
  cpf?: string;
  grupo?: number;
  id?: number;
  nome?: string;
  perfil?: number;
  prefixoGrupo?: string;
  extensaoImg?: string;
  isRm?: boolean;
  isOperador?: boolean
  isCoordenador?: boolean
}
